"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const util_1 = require("../../../util");
const Stringify_1 = require("./Stringify");
exports.TextWithCaption = ({ value: val, row, col, colIndex, onAction, rowIndex, className, }) => {
    const generatedId = `super-table-text-caption-${row._id}-${col.id}`;
    let value = {};
    if (typeof val === "string" ||
        typeof val === "number" ||
        typeof val === "boolean") {
        value = { text: val.toString() };
    }
    else {
        if (val.text) {
            value = val;
        }
        else {
            value.text = val;
        }
    }
    const doAction = () => {
        var _a;
        if (!col.action)
            return;
        const { params, event: actionEvent } = col.action;
        const constructParams = util_1.convertSerializedIntoJS(params, row, col);
        const event = util_1.convertSerializedIntoJS(actionEvent, row, col);
        const props = {
            ...col.action,
            action: (_a = col.action) === null || _a === void 0 ? void 0 : _a.type,
            event,
            creator: { row, column: col, colIndex, rowIndex },
            params: constructParams,
        };
        onAction(props);
    };
    const tooltip = value.tooltip || value.text;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: ` ${className} text-truncate p-1` },
            react_1.default.createElement("span", { id: generatedId, className: `${col.action ? "cursor-pointer" : ""}`, onClick: () => doAction() },
                react_1.default.createElement(Stringify_1.Stringify, { col: col, value: value.text })),
            tooltip && (react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { placement: "right", target: generatedId },
                react_1.default.createElement(Stringify_1.Stringify, { col: col, value: tooltip })))),
        value.caption && (react_1.default.createElement("div", { className: "text-truncate p-1" },
            react_1.default.createElement("small", null,
                react_1.default.createElement(Stringify_1.Stringify, { col: col, value: value.caption }))))));
};
//# sourceMappingURL=TextWithCaption.js.map